// copied from https://github.com/ngxtension/ngxtension-platform/blob/main/libs/ngxtension/assert-injector/src/assert-injector.ts
import { Injector, assertInInjectionContext, inject, runInInjectionContext } from '@angular/core';

/**
 * `assertInjector` extends `assertInInjectionContext` with an optional `Injector`
 * After assertion, `assertInjector` returns a guaranteed `Injector` whether it is the default `Injector`
 * within the current **Injection Context** or the custom `Injector` that was passed in.
 *
 * @param {Function} fn - the Function to pass in `assertInInjectionContext`
 * @param {Injector | undefined | null} injector - the optional "custom" Injector
 * @returns Injector
 *
 * @example
 * ```ts
 * function injectDestroy(injector?: Injector) {
 *  injector = assertInjector(injectDestroy, injector);
 *
 *  return runInInjectionContext(injector, () => {
 *    // code
 *  })
 * }
 * ```
 */
export function assertInjector(fn: Function, injector: Injector | undefined | null): Injector;
export function assertInjector(fn: Function, injector: Injector | undefined | null, runner?: () => any) {
    !injector && assertInInjectionContext(fn);
    const assertedInjector = injector ?? inject(Injector);

    if (!runner) return assertedInjector;
    return runInInjectionContext(assertedInjector, runner);
}
